import { Disclosure } from '@headlessui/react';
import { Icon } from '../../../../../core/components/atoms/Icon';
import { Typography } from '../../../../../core/components/molecules/Typography';
import { useUserStore } from '../../../../Auth/stores/authStore';

interface ICompetenceCardProps {
  score: string;
  description: string;
  competencia?: string;
  comment: string;
  defaultOpen: boolean;
}

const CompetenceCard: React.FC<ICompetenceCardProps> = ({
  score,
  description,
  competencia,
  comment,
  defaultOpen = false,
}) => {
  const { user } = useUserStore();

  return (
    <div className='gap-xl rounded-md bg-mono-color-white px-4 py-3'>
      <Disclosure defaultOpen={defaultOpen}>
        {({ open }) => (
          <>
            <Disclosure.Button className='w-full'>
              <div className='flex flex-row items-center justify-between gap-xxl'>
                <div className='w-fit'>
                  {competencia && (
                    <Typography size='h6' type='titleSection' weight='bold'>
                      {competencia}
                    </Typography>
                  )}
                  <Typography
                    size='h3'
                    type='title'
                    weight='bold'
                    className='xs:hidden md:block'
                  >
                    {score}
                  </Typography>
                </div>
                <div className='xs:hidden md:block md:flex-1'>
                  <Typography className='text-left'>{description}</Typography>
                </div>
                {!defaultOpen && (
                  <div className='w-fit'>
                    <div className='flex flex-row items-center gap-sm'>
                      <Typography
                        type='title'
                        size='h4'
                        weight='bold'
                        className='xs:block md:hidden'
                      >
                        {score}
                      </Typography>
                      <Icon
                        Icon='expand_more'
                        type='material'
                        className={`${open ? 'rotate-180 transform' : ''} text-md ${!user?.isDarkMode ? 'text-brand-color-primary-pure' : 'text-mono-color-black'}`}
                      />
                      <Typography
                        size='small'
                        className={`${!user?.isDarkMode ? 'text-brand-color-primary-pure' : 'text-mono-color-black'} xs:hidden md:block`}
                      >
                        {open ? 'Minimizar' : 'Ver comentário'}
                      </Typography>
                    </div>
                  </div>
                )}
              </div>
            </Disclosure.Button>
            <Disclosure.Panel className='text-gray-500 mt-4 flex flex-col gap-sm'>
              <Typography
                type='titleSection'
                size='h6'
                weight='bold'
                className='text-mono-color-black'
              >
                Comentário
              </Typography>
              <Typography className='italic text-mono-color-black'>
                {comment}
              </Typography>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
};

export default CompetenceCard;
